import { useAuth } from 'context/AuthProvider'
import PropTypes from 'prop-types'
import { useMemo } from 'react'
import { RouterProvider } from 'react-router-dom'
import QueryClient from 'services/query'
import { initSentry } from 'services/sentry'
import { encodedURL } from 'services/url'
import { router } from './router'
import { publicRouter } from './router-public'

initSentry()

export default function App({ client }) {
  const { user } = useAuth()
  let from = encodedURL()

  // Do not include `?from` on these pages
  from = ['404', 'login'].some(error => from.includes(error)) ? '/' : from
  const privateRouter = useMemo(() => router({ queryClient: client }), [client])
  const guestRouter = useMemo(() => publicRouter({ queryClient: client, from }), [client, from])

  return user ? <RouterProvider router={privateRouter} /> : <RouterProvider router={guestRouter} />
}

App.propTypes = {
  client: PropTypes.instanceOf(QueryClient),
}
